<template>

  <div class="page-wrap">
    <page-renderer
      v-if="!isExternalBlank"
      class="page-iframe"
      :page="page"
      :render-mode="renderMode"
      @rendered="onRendered"
      @reload="onReload()"
    />
  </div>
</template>

<script>
import PageRenderer from "@/components/PageRenderer";
import { attachIframeScrollListener } from "@/utils/iframe";
import { isExternalBlankTarget } from "@/utils/navigation";

export default {
  name: 'HomeView',
  components: {PageRenderer},
  data() {
    let page = this.$route.meta.page;
    let renderMode = this.$route.meta.renderMode;
    let navItem;
    if(typeof page === "undefined") {
      const path = typeof this.$route.params.path !== "undefined" ? this.$route.params.path : 'home'
      navItem = this.$store.getters.navigation[path];
      page = navItem.page;
      renderMode = navItem.renderMode;
    }

    return {
      lastScrollTop: 0,
      scrollDirection: 'up',
      loaded: false,
      page,
      renderMode,
      isExternalBlank: isExternalBlankTarget(navItem),
      externalPage: navItem && navItem.page
    }
  },

  mounted() {
    // Deep links to target:_blank pages must not load via PageRenderer
    // (that would fetch and cache remote HTML). Open externally instead.
    if (this.isExternalBlank && this.externalPage) {
      window.open(this.externalPage, '_blank', 'noopener,noreferrer');
      const ticket = this.$store.getters.ticket;
      const token = this.$store.getters.token;
      this.$router.replace('/' + ticket + '/' + token);
      this.$emit('loaded');
    }
  },

  methods: {
    onReload() {
      this.$emit('reload');
    },

    onRendered() {
      const iFrame = document.querySelector('.page-iframe');
      if(iFrame) {
        attachIframeScrollListener(iFrame, e => this.onScroll(e));
      }
      this.$emit('loaded');
    },

    onScroll(e) {
      const elementWindow = e.currentTarget;
      const elementDocument = e.target;
      const st = elementWindow.scrollY || elementDocument.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > this.lastScrollTop){
        if(this.scrollDirection === "up") {
          this.scrollDirection = 'down';
          this.$emit('scroll', 'down')
        }
      } else {
        if(this.scrollDirection === "down") {
          this.scrollDirection = 'up';
          this.$emit('scroll', 'up')
        }
      }
      this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
  }
}
</script>


<style lang="scss">
iframe {
  opacity: 0;
  width: 100vw;
  height: calc(100vh - 73px);
  transition: opacity .5s;
  &.show {
    opacity: 1;
  }
}
</style>